

























































import { Component, Prop, Watch, Inject, Vue } from "vue-property-decorator";
import UploadPicture from "@/components/app/images/upload-picture.vue";
import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import BSwitch from "@/components/app/switchs/b-switch.vue";

import { IFilmCategory as ICat } from "@/@types/cinema/film-category";
import { ILocale } from "@/@types/locale";
import type { SICON } from "@/@types/_shared/src";
import { pics } from "@/config/host.config";

@Component({
  components: {
    submit: SubmitResetButtonGroop,
    BSwitch,
    UploadPicture,
  },
})
export default class ChangeCategoryForm extends Vue {
  @Prop({ type: Object, default: null }) category!: ICat;
  @Inject("categoryFolder") readonly folder!: string;
  picsUrl = pics.cinema;

  name = "";
  poster = "";
  show = true;
  sortOrder: number | undefined;
  names: ILocale = {};

  icon = "";
  iconLib = "";
  iconLibs = ["bi", "material", "fa", "filoxenia", ""];

  get languages(): Array<string> {
    return this.$store.getters.getLanguages;
  }

  locale = this.$store.getters.getLanguages[0];

  get cat(): ICat {
    return {
      _id: this.category ? this.category._id : "",
      show: this.show,
      name: this.names,
      sort_order: this.sortOrder,
      src: {
        poster: this.poster,
        icon: {
          icon: this.icon,
          lib: this.iconLib as SICON["lib"],
        },
      },
    };
  }

  @Watch("name")
  addName(): void {
    this.names[this.locale] = this.name;
  }

  @Watch("locale")
  routerLocalesName(): void {
    if (this.names)
      this.name = this.names[this.locale] ? this.names[this.locale] : "";
    else this.name = "";
  }

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    this.$emit("update", this.cat, this.cat._id);
    this.onReset();
  }

  onReset(): void {
    this.name = "";
    this.poster = "";
    this.names = {};
    this.show = false;
    this.icon = "";
    this.iconLib = "";
    this.locale = this.languages[0];
  }

  @Watch("category")
  startChangeCategory(): void {
    if (!this.category) return;

    this.show = this.category.show;
    this.names = this.category.name;
    this.sortOrder = this.category.sort_order;
    this.poster =
      this.category.src && this.category.src.poster
        ? this.category.src.poster
        : "";
    this.icon =
      this.category.src && this.category.src.icon
        ? this.category.src.icon.icon
        : "";
    this.iconLib =
      this.category.src && this.category.src.icon
        ? this.category.src.icon.lib
        : "";
    this.routerLocalesName();
  }

  mounted(): void {
    this.startChangeCategory();
  }
}
